/* v3 swap: the Insights route now renders the v3 "Weekly" magazine
   (src/v2/v3/Insights.jsx) instead of the old 4-bucket card page.

   The old card composition (useInsights / InsightBucket / latest list)
   is replaced wholesale per the v3 rebuild. Those modules are left in
   place (not deleted) but are no longer mounted by this route.

   The /insights/:id detail route (V2InsightDetailPage, elsewhere) is
   left untouched — it's orphaned under the new single-magazine model;
   the Insights-engine epic will resolve detail navigation. */
import { Insights } from '@/v2/v3/Insights'

export function V2InsightsPage() {
  return <Insights />
}
